 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ "create.txtQuest" | translate }} </span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content style="text-align: center;margin: -1px auto 0;">
     <div class="default">
      <div class="info-field d-flex flex-column">
        <div class="block-icons d-flex justify-content-center align-items-center" >
          @for (icon of data.field.icons; track $index) {
            <div class="block-icons__icon" [style.background-color]="addOpacity(data.field.sector_color)">
                <span class="material-symbols-outlined" [style.color]="data.field.sector_color">
                  {{ icon }}
                </span>
            </div>
          }
        </div>
        <span class="info-field__title">{{ data.field.title }}</span>
        <div class="line-all"></div>
        <span class="info-field__description">{{ data.field.comment }}</span>
        @if(allStatus$.maxPointresultCard > 0){
          <span class="info-field__xp">+{{ allStatus$.maxPointresultCard }} XP</span>
        }
      </div>

    </div>    
 </mat-dialog-content>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick()">
             <span>{{ 'buttons.txtClose' | translate }}</span>
         </button>
     </div>       
   </mat-dialog-actions>
